import React from 'react';
import { Check } from 'lucide-react';
export function WhatIncluded() {
  const items = ['30 cenas anti-pelea (niños 3-10)', '4 menús semanales detallados', 'Listas de compras por semana', '12 puentes (salsas/toppings/formatos)', 'Plan B "hoy no"', 'FAQ + glosario'];
  return <section className="py-16 md:py-24 px-4 bg-[#F6EEDC]" data-id="element-265">
      <div className="max-w-3xl mx-auto" data-id="element-266">
        <div className="text-center mb-12" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E] mb-4" data-id="element-268">
            Qué incluye
          </h2>
        </div>

        <div className="bg-[#FDFBF9] rounded-xl p-6 md:p-8 shadow-sm border border-[#2E2E2E]/5" data-id="element-269">
          <ul className="space-y-4" data-id="element-270">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-271">
                <div className="w-6 h-6 bg-[#0D3B66] rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-272">
                  <Check className="w-4 h-4 text-white" data-id="element-273" />
                </div>
                <span className="text-[#2E2E2E] text-base md:text-lg" data-id="element-274">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 pt-6 border-t border-[#2E2E2E]/10" data-id="element-275">
            <p className="text-[#2E2E2E]/70 text-sm md:text-base leading-relaxed" data-id="element-276">
              Enfocado en huevo/legumbres (casi sin carne) + opciones flexibles.
            </p>
          </div>
        </div>
      </div>
    </section>;
}